import type React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { NounSubtypeKey } from '../../filters/universal-type';
import { SharepointArchiveIcon } from '../../icons/sharepoint-archive';
import { SharepointAudioIcon } from '../../icons/sharepoint-audio';
import { SharepointDocumentIcon } from '../../icons/sharepoint-document';
import { SharepointFolderIcon } from '../../icons/sharepoint-folder';
import { SharepointImageIcon } from '../../icons/sharepoint-image';
import { SharepointPdfIcon } from '../../icons/sharepoint-pdf';
import { SharepointPresentationIcon } from '../../icons/sharepoint-presentation';
import { SharepointSpreadsheetIcon } from '../../icons/sharepoint-spreadsheet';
import { SharepointVideoIcon } from '../../icons/sharepoint-video';

/**
 * Returns the SharePoint file-type-specific icon for a given NounSubtype.
 */
export const getSharePointFileTypeIcon = (
	subtype: string | null | undefined,
): (() => React.JSX.Element) | null => {
	if (!fg('rovo_fps_3p_file_type_icons_sharepoint')) {
		return null;
	}
	switch (subtype) {
		case NounSubtypeKey.Folder:
			return SharepointFolderIcon;
		case NounSubtypeKey.Document:
			return SharepointDocumentIcon;
		case NounSubtypeKey.Spreadsheet:
			return SharepointSpreadsheetIcon;
		case NounSubtypeKey.Presentation:
			return SharepointPresentationIcon;
		case NounSubtypeKey.Image:
			return SharepointImageIcon;
		case NounSubtypeKey.Pdf:
			return SharepointPdfIcon;
		case NounSubtypeKey.Video:
			return SharepointVideoIcon;
		case NounSubtypeKey.Archive:
			return SharepointArchiveIcon;
		case NounSubtypeKey.Audio:
			return SharepointAudioIcon;
		default:
			return null;
	}
};
